module.exports = __webpack_public_path__ + "assets/img/help_image04-2.6e58612a.png";